module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEySURBVHgB3VTREYIwDK2cA+AGHUEnECfw3IARdAJ1At1A3MANZAPcQDeADWqi4eRKS58n5wfv7h2lSV9Ik6DUoGGM2RJL0w8OviCJ6R9prR85YuajH0EaZ1s0Un8CHIiuQROv5lNDXmv0PBRIBAtiQoxlm9d3ri2igWZ0kgB89xPhvmHD0ei6q8NWQ1v7pWc/Q7quC5XnPQ4dRAPl8jxIU8QykJr4oI6+hQTGCsOGyFeaCm1bEFBG8sUz9W6GSpgTF2S7IBpoRhzsodrZwEDniGuylSGtURCP6NAGMxIhro+2TFPhknxWoYaIvgjCQgviRH6cvM7Fhv+OXAPbGLw7X5/nXNZxLoUyIszlyVdTeXzW6t2Fie9jGM0a1UKvzCy/or3lRGn5lU4vctqZ/pCpQeMJ1LPNdNFM0XoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/User_Square.png
// module id = 4LaS
// module chunks = 1